import moment from "moment-timezone";
import dayjsTZ from "../../../../utils/dayjs";
import { message } from "antd";
import { API } from "aws-amplify";
import { htmlParser } from "../../../../utils";
import { groupSingleShift } from "../../../Pagat/PaySub/employeeCalc/calculcate";
import { currencyformatter } from "../../../Pagat/PaySub/employeeCalc/methods";
import { getTranslation } from "../../generate/translations";
import { store } from "../../../../store";

import { getDayTypeTranslations } from "../approvals/approvals";
import { groupBy } from "lodash";
export const clockingTypesReports = (prevData, filter, columns, manualColumns, other) => {
	let result = {
		columnsDef: [],
		allColumns: [],
		rowData: [],
		selectedColumns: [],
		allColumns: [],
	};
	const data = store?.getState().customReducer?.reportClockings || [];
	if (!!data && !!filter) {
		const missingShifts = [];
		other
			?.filter((d) => d?.employeeStatus === "Aktiv" && d?.employeePayrollType !== "Page Fikse")
			?.forEach((d) => {
				let validShifts = data?.filter((e) => e?.employeeId === d?.employeeId);
				let missingDates = getDates(
					filter?.timeInterval[0],
					filter?.timeInterval[1],
					validShifts,
					d
				);
				missingShifts.push(...missingDates);
				console.log("missingDates", missingDates);
			});
		console.log("missingShifts", missingShifts);
		result.selectedColumns = manualColumns || columns.columnDefs;
		result.allColumns = columns.allAppliedColumnDefs;
		const merged = data.concat(missingShifts)?.sort((a, b) => a.clockInDate - b.clockInDate);

		const preFilter = merged
			?.filter(
				(d) =>
					d.clockInDate >= dayjsTZ(filter?.timeInterval[0]).startOf("day").valueOf() &&
					d.clockInDate <= dayjsTZ(filter?.timeInterval[1]).endOf("day").valueOf()
			)
			.map((d) => {
				if (d?.dayType === "MUNGESE") {
					console.log("getDayTypeTranslations", getDayTypeTranslations(d?.dayType || ""));
					return {
						...d,
						...d?.employeeDetails,
						employeeDayOfBirth: dayjsTZ(d?.employeeDetails?.employeeDayOfBirth).format("DD/MM/YYYY"),
						employeeHireDate: dayjsTZ(d?.employeeDetails?.employeeHireDate).format("DD/MM/YYYY"),
						clockInDate: dayjsTZ(d.clockInDate).format("HH:mm"),
						clockInPayment: currencyformatter.format(d?.totalities?.totalPay || 0) || 0,
						clockInRate: currencyformatter.format(d?.totalities?.employeeRate || 0) || 0,
						employee: `${d?.employeeDetails?.employeeFirstName} ${d?.employeeDetails?.employeeLastName}`,
						approved: d?.approved ? "Aprovuar" : "Pa Aprovuar",
						clockDate: dayjsTZ(d.clockInDate).format("DD/MM/YYYY"),
						clockOutDate: !!d.clockOutDate ? dayjsTZ(d.clockOutDate).format("HH:mm") : "Not closed",
						clockInNote: !!d?.clockInNote ? htmlParser(d?.clockInNote) : "",
						duration: "0.00",
						before19: "0.00",
						between19and22: "0.00",
						after22: "0.00",
						dayType: getDayTypeTranslations(d?.dayType || ""),
						breakTime: "-",
						breakTimeVal: 0,
					};
				}
				const { EXTRA_HOURS = 0, LATE_HOURS = 0, NORMAL_HOURS = 0 } = groupSingleShift(d) || null;
				// console.log("groupSingleShift", groupSingleShift(d));
				// console.log("NORMAL_HOURS", d);
				// console.log("d", d);
				return {
					...d,
					...d?.employeeDetails,
					employeeDayOfBirth: dayjsTZ(d?.employeeDetails?.employeeDayOfBirth).format("DD/MM/YYYY"),
					employeeHireDate: dayjsTZ(d?.employeeDetails?.employeeHireDate).format("DD/MM/YYYY"),
					clockInDate: dayjsTZ(d.clockInDate).format("HH:mm"),
					clockInPayment: currencyformatter.format(d?.totalities?.totalPay || 0) || 0,
					clockInRate: currencyformatter.format(d?.totalities?.employeeRate || 0) || 0,
					employee: `${d?.employeeDetails?.employeeFirstName} ${d?.employeeDetails?.employeeLastName}`,
					approved: d?.approved ? "Aprovuar" : "Pa Aprovuar",
					clockDate: dayjsTZ(d.clockInDate).format("DD/MM/YYYY"),
					clockOutDate: !!d.clockOutDate ? dayjsTZ(d.clockOutDate).format("HH:mm") : "Not closed",
					clockInNote: !!d?.clockInNote ? htmlParser(d?.clockInNote) : "",
					duration: !!d?.clockOutDate
						? parseFloat(
								dayjsTZ(d?.clockOutDate).diff(dayjsTZ(d?.clockInDate), "hours", true).toFixed(2)
						  )
						: 0,
					before19: parseFloat(NORMAL_HOURS?.amount?.toFixed(2) || 0),
					between19and22: parseFloat(LATE_HOURS?.amount.toFixed(2) || 0),
					after22: parseFloat(EXTRA_HOURS?.amount?.toFixed(2) || 0),
					dayType: getDayTypeTranslations(d?.dayType || ""),
					breakTime:
						!!d?.totalities?.breakTime?.length > 0
							? `${d?.totalities?.breakTime?.[0] + " - " + d?.totalities?.breakTime?.[1]}`
							: "",
					breakTimeVal: d?.totalities?.breakTimeVal?.toFixed(2) || 0,
				};
			});

		let groupedEmployeeShifts = groupBy(preFilter, "employeeId");
		let res = [];
		Object.entries(groupedEmployeeShifts).forEach(([key, value]) => {
			let shiftTypeTotals = {
				regularDays: 0,
				sickDays: 0,
				holidayRequestDays: 0,
				nationalHolidayDays: 0,
				nationalHolidayWorkedDays: 0,
				maternityDays: 0,
				missingDays: 0,
				employeeId: value[0]?.employeeId,
				employee: value[0]?.employee,
				employeeTeam: value[0]?.employeeTeam,
				employeeDepartmentName: value[0]?.employeeDepartmentName,
			};
			let groupedByClockDate = groupBy(value, "clockDate");
			Object.entries(groupedByClockDate).forEach(([key2, value2]) => {
				console.log("value2", value2);
				const uniqueShiftDays = removeDuplicatesDayTypes(value2, "dayType");
				uniqueShiftDays.forEach((e) => {
					let type = adaptShifts(e.dayType);
					let myObj = shiftTypeTotals?.[`${adaptShifts(e.dayType)}`];
					console.log("myObj", { myObj, type });
					shiftTypeTotals[`${adaptShifts(e.dayType)}`] += 1;
				});
			});
			res.push(shiftTypeTotals);
		});
		console.log("shiftTypeTotals", res);

		if (!!manualColumns && Array.isArray(manualColumns)) {
			manualColumns.forEach((e) => {
				result.columnsDef.push(getTranslation(e));
			});
			res.forEach((emplRecord) => {
				let toAdd = [];
				manualColumns.forEach((c) => toAdd.push(emplRecord[c]));
				result.rowData.push(toAdd);
			});
		} else {
			columns?.columnDefs.forEach((e) => {
				result.columnsDef.push(getTranslation(e));
			});
			res.forEach((emplRecord) => {
				// console.log("preFilter", preFilter);
				let toAdd = [];
				columns?.columnDefs?.forEach((c) => toAdd.push(emplRecord[c]));
				result.rowData.push(toAdd);
			});
		}

		return result;
	}
};

const adaptShifts = (shiftType) => {
	console.log("shiftType", shiftType);
	switch (shiftType) {
		case "Normal":
			return "regularDays";

		case "Sëmurë":
			return "sickDays";

		case "Kërkesë Leje":
			return "holidayRequestDays";
		case "Festë Zyrtare":
			return "nationalHolidayDays";
		case "Festë Zyrtare Punë":
			return "nationalHolidayWorkedDays";
		case "Leje Lindje":
			return "maternityDays";
		case "MUNGESE":
			return "missingDays";
		default:
			return "undefined";
	}
};

const removeDuplicatesDayTypes = (array) => {
	const unique = array.filter(
		(obj, index, self) => index === self.findIndex((t) => t?.dayType === obj?.dayType)
	);
	return unique;
};
export function getDates(startDate, endDate, validShifts, employeeDetails) {
	console.log("get dates", { startDate, endDate, validShifts, employeeDetails });
	var dates = [];
	var tempEnd = dayjsTZ().endOf("day").valueOf();
	var currentDate = dayjsTZ(startDate).valueOf();
	let employeeHireDate = !!employeeDetails?.employeeHireDate
		? dayjsTZ(employeeDetails?.employeeHireDate).valueOf()
		: currentDate;
	console.log("employeeHireDate", employeeHireDate);
	while (currentDate <= tempEnd) {
		if (dayjsTZ(currentDate).day() !== 0 && dayjsTZ(currentDate).day() !== 6) {
			if (
				!validShifts?.some(
					(e) =>
						dayjsTZ(e.clockInDate).format("DD/MM/YYYY") === dayjsTZ(currentDate).format("DD/MM/YYYY")
				) &&
				currentDate >= employeeHireDate
			) {
				dates.push(dayjsTZ(currentDate).format("DD/MM/YYYY"));
			}
		}
		currentDate = dayjsTZ(currentDate).add(1, "days").valueOf();
	}
	const toReturn = dates?.map((el) =>
		clockInObj(
			dayjsTZ(el, "DD/MM/YYYY 13:00"),
			dayjsTZ(el, "DD/MM/YYYY 13:00"),
			"MUNGESE",
			"manualAdmin",
			true,
			employeeDetails
		)
	);
	console.log("toReturn", dates);

	return toReturn;
	console.log("toReturn", dates);
}

export const clockInObj = (
	clockInDate,
	clockOutDate,
	dayType = "MUNGESE",
	clockingCategory = "manualAdmin",
	approved = true,
	employeeDetails
) => {
	return {
		clockInDate,
		clockOutDate,
		dayType,
		clockingCategory,
		approved,
		employeeId: employeeDetails?.employeeId,
		employeeDetails,
		duration: "0.00",
		before19: "0.00",
		between19and22: "0.00",
		after22: "0.00",
		breakTime: "",
		breakTimeVal: 0,
	};
};
